import BambooIcon from "@/integrations/bamboo-hr/assets/bamboo-icon.svg";
import {
	INTEGRATION_NAME as PEOPLE_PENSION,
	INTEGRATION_LOGO as PEOPLE_PENSION_LOGO,
} from "@/integrations/peoplePension/store/config";
import {
	INTEGRATION_NAME as SMART_PENSION,
	INTEGRATION_LOGO as SMART_PENSION_LOGO,
} from "@/integrations/smartPension/store/config";
import {
	AcademicCapIcon,
	BackwardIcon,
	BanknotesIcon,
	BuildingLibraryIcon,
	DocumentTextIcon,
	UserIcon,
	ReceiptPercentIcon,
	BellIcon,
	CloudArrowUpIcon,
	BoltIcon,
} from "@heroicons/react/20/solid";
import HMRCLogo from "../common/icons/hmrc.svg";
import Buddy from "@/images/buddy-face.png";
import Workforce from "@/integrations/workforce/assets/workforce-logo.svg";
const WorkforceLogo = (props) => {
	return (
		<img
			src={Workforce}
			alt="Workforce Logo"
			{...props}
		/>
	);
};

const NotificationIcons = {
	"agreement": UserIcon,
	"role": AcademicCapIcon,
	"salary": BanknotesIcon,
	"previous earnings": BackwardIcon,
	"tax": DocumentTextIcon,
	"bank": BuildingLibraryIcon,
	"pension": ReceiptPercentIcon,
	"notification": BellIcon,
	"update": CloudArrowUpIcon,
	"Workforce": WorkforceLogo,
};

const SectionIcons = {
	"Buddy": () => {
		return (
			<img
				src={Buddy}
				alt="Buddy Logo"
				style={{ height: "3rem", marginRight: "1rem" }}
			/>
		);
	},
	"HMRC": () => {
		return (
			<img
				src={HMRCLogo}
				alt="HMRC Logo"
				style={{ height: "3rem", marginRight: "1rem" }}
			/>
		);
	},
	"Bamboo HR": () => {
		return (
			<img
				src={BambooIcon}
				alt="Bamboo HR Logo"
				style={{ height: "3rem", marginRight: "1rem" }}
			/>
		);
	},
	"Auto Enrolment": () => {
		return (
			<ReceiptPercentIcon
				style={{
					padding: "0.5rem",
					height: "3rem",
					borderRadius: "5rem",
					marginRight: "1rem",
					color: "white",
					background: "#ea611c",
					verticalAlign: "middle",
				}}
			/>
		);
	},
	[PEOPLE_PENSION]: () => {
		return (
			<img
				src={PEOPLE_PENSION_LOGO}
				alt={`${PEOPLE_PENSION} Logo`}
				style={{
					height: "4rem",
					width: "4rem",
					marginRight: "1rem",
					background: "white",
					padding: "0.25rem",
					borderRadius: "1rem",
				}}
			/>
		);
	},
	[SMART_PENSION]: () => {
		return (
			<img
				src={SMART_PENSION_LOGO}
				alt={`${SMART_PENSION} Logo`}
				style={{
					height: "4rem",
					width: "4rem",
					marginRight: "1rem",
					borderRadius: "1rem",
				}}
			/>
		);
	},
	"Integrations": () => {
		return (
			<BoltIcon
				style={{
					padding: "0.5rem",
					height: "3rem",
					borderRadius: "5rem",
					marginRight: "1rem",
					color: "white",
					background: "#ea611c",
					verticalAlign: "middle",
				}}
			/>
		);
	},
};

export { NotificationIcons, SectionIcons };
